
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { createGraphNodeClicker, BarChart, DashboardGraph } from 'graph'
import { useGraphFetch, constants } from '../module'
import { useSelectedFleetIds } from 'features/settings'
import { v4 as uuid } from 'uuid'
import { types as emissionTypes } from 'features/report-vehicle-emissions'

const Graph = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const selectedFleetIds = useSelectedFleetIds()

  const { loading, error, data } = useGraphFetch()
  const path = '/reports/vehicle-emissions'

  const onClick = createGraphNodeClicker(data?.ranges, (key, value) => {
    if (key && value) {
      dispatch({ type: emissionTypes.SET_DASHBOARD_FILTER, payload: true })
      navigate(`${path}?${key}=${value}`)
    } else {
      navigate(`${path}`)
    }
  })
  const onRefresh = () => {
    dispatch({
      type: constants.REQUEST_DATA,
      payload: null,
      options: {
        queryParams: { FleetId: selectedFleetIds.join() },
        requestId: uuid()
      }
    })
  }

  return (
    <DashboardGraph
      title="Sustainability – CO₂e Emissions (tons/month)"
      to={path}
      loading={loading}
      error={error}
      onRefresh={onRefresh}
      data={data}
      minHeight={300}>
      {data && (
        <BarChart
          data={data}
          noDataMessage="No Sustainability emissions data available for the selected fleet."
          onClick={onClick}/>
      )}
    </DashboardGraph>
  )
}

export default Graph
